import React from 'react';
import { Divider } from '../../../Divider/Divider';
import {
  COLORS,
  FONTS,
  COPYRIGHT_NOTICE,
  LEGAL_ADDRESS_TEXT,
  PRIVACY_POLICY_TITLE,
  COOKIES_TITLE,
  device,
} from '../../../../constants';
import styled from 'styled-components';
import { InnowiseIcon } from '../../../../assets/svg';

export const FooterDetails = () => (
  <React.Fragment>
    <Divider />
    <FooterContainer>
      <InfoBlock>
        <InnowiseIcon color="white" />
        <div>
          <div>
            <Text>{COPYRIGHT_NOTICE}</Text>
            <SocialLink
              href={process.env.REACT_APP_LINK_INNOWISE_PRIVACY}
              target="_blank"
              rel="noopener noreferrer"
            >
              {PRIVACY_POLICY_TITLE}
            </SocialLink>
            <SocialLink
              href={process.env.REACT_APP_LINK_INNOWISE_COOKIE}
              target="_blank"
              rel="noopener noreferrer"
            >
              {COOKIES_TITLE}
            </SocialLink>
          </div>
          <LegalAddressText>{LEGAL_ADDRESS_TEXT}</LegalAddressText>
        </div>
      </InfoBlock>
    </FooterContainer>
  </React.Fragment>
);

const FooterContainer = styled.div`
  padding-top: 30px;
  align-items: center;
  @media screen and ${device.md} {
    padding-top: 10px;
  }
`;

const InfoBlock = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 100px;
  @media screen and ${device.md} {
    flex-direction: column;
    gap: 15px;
  }
`;

const SocialLink = styled.a`
  color: ${COLORS.WHITE};
  font-size: 16px;
  line-height: 24px;
  font-family: ${FONTS.SUBTITLE};
  text-decoration: none;
  font-weight: 400;
  margin-left: 10px;

  &:hover {
    text-decoration: underline;
    color: ${COLORS.MAIN_RED};
  }
`;

const Text = styled.span`
  color: ${COLORS.FOOTER_TEXT_COLOR};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: left;
  font-family: ${FONTS.SUBTITLE};
`;

const LegalAddressText = styled(Text)`
  display: block;
  margin-top: 4px;
  font-size: 14px;
  @media screen and ${device.md} {
    text-align: center;
  }
`;
